"use client";

import classNames from "classnames";
import Link from "next/link";
import { usePathname } from "next/navigation";

function MenuLink({
  href,
  children,
}: {
  href: string;
  children: React.ReactNode;
}) {
  const pathname = usePathname();

  return (
    <li>
      <Link
        href={href}
        className={classNames(
          pathname === href
            ? "bg-gray-800 font-semibold text-white"
            : "text-gray-400 hover:bg-gray-800 hover:text-white",
          "group flex gap-x-3 rounded-md p-3 leading-6 relative"
        )}
      >
        {children}
      </Link>
    </li>
  );
}

export default MenuLink;
